module.exports = __webpack_public_path__ + "img/70f64bc.jpg";